/**
 * Règles de paiement à la réservation.
 * - Domicile : acompte de 30 € en ligne, solde le jour du rendez-vous (+ supplément éventuel)
 * - Visio : paiement de la totalité en ligne
 * - Cabinet : aucun paiement en ligne, règlement sur place
 */

export const DEPOSIT_AMOUNT = 30;

export const PAID_BOOKING_SERVICES = [
  "Bilan naturopathique – Enfants & Adolescents",
  "Bilan naturopathique – Adultes",
  "PARCOURS FAMILLE COURAGEUSE",
];

const normalize = (value: string) =>
  value
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9]+/g, " ")
    .trim();

export function isPaidBookingService(title?: string | null): boolean {
  if (!title) return false;
  const n = normalize(title);
  return PAID_BOOKING_SERVICES.some((s) => normalize(s) === n);
}

export function parsePrice(tarif?: string | number | null): number {
  if (typeof tarif === "number") return tarif;
  if (!tarif) return 0;
  const match = String(tarif).replace(",", ".").match(/[\d]+(\.[\d]+)?/);
  return match ? parseFloat(match[0]) : 0;
}

export interface BookingPayment {
  /** Le paiement en ligne est requis pour valider la réservation */
  required: boolean;
  /** Montant à régler en ligne */
  amountToPay: number;
  /** Prix total de l'accompagnement (hors supplément) */
  price: number;
  /** Supplément de déplacement éventuel */
  surcharge: number;
  /** Solde restant à régler le jour du rendez-vous */
  balance: number;
  mode: "none" | "deposit" | "full";
}

export function getBookingPayment(params: {
  serviceTitle?: string | null;
  tarif?: string | number | null;
  isOnline?: boolean;
  isHomeVisit?: boolean;
  surcharge?: number;
}): BookingPayment {
  const price = parsePrice(params.tarif);
  const surcharge = params.surcharge || 0;
  const eligible = isPaidBookingService(params.serviceTitle) && price > 0;

  if (!eligible) {
    return { required: false, amountToPay: 0, price, surcharge, balance: price + surcharge, mode: "none" };
  }

  if (params.isHomeVisit) {
    const deposit = Math.min(DEPOSIT_AMOUNT, price);
    return {
      required: true,
      amountToPay: deposit,
      price,
      surcharge,
      balance: Math.max(0, price - deposit) + surcharge,
      mode: "deposit",
    };
  }

  if (params.isOnline) {
    return { required: true, amountToPay: price, price, surcharge: 0, balance: 0, mode: "full" };
  }

  // Cabinet : règlement sur place
  return { required: false, amountToPay: 0, price, surcharge: 0, balance: price, mode: "none" };
}

export const formatEuro = (value: number) =>
  `${Number.isInteger(value) ? value : value.toFixed(2)} €`;
